<template>
  <div class="instrument_index">
    <!-- <span>1、科室模板 2、手术模板 3、回收模板</span> -->
    <div class="search-line">
        <div class="left">
            <el-select v-model="queryParams.name" clearable filterable placeholder="请选择模板">
              <el-option
                v-for="item in templeteOption"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
            <el-select class="ml10" v-model="queryParams.department_name" clearable filterable placeholder="请选择科室">
              <el-option
                v-for="item in deptOptions"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
            <el-button class="ml10" type="primary" icon="el-icon-search" size="mini" @click="getSearch">查询</el-button>
            <el-button type="primary" icon="el-icon-plus" size="mini" @click="createTemplate">新建</el-button>
        </div>
        <table-header-editor :headers="tableHeaders" class="header-editor" />
    </div>
    <div class="instrument_center mt10">
        <div class="list-content">
        <el-table
            :data="templetedataList"
            stripe 
            v-loading="loading"
            :header-cell-class-name="'table-header-cell'"
            @sort-change="sortChange"
            border
        >
            <el-table-column
            v-for="(item) in tableHeaders"
            :key="item.id"
            :type="item.type"
            :label="item.label"
            :prop="item.prop"
            :sortable="!!item.sortKey ? 'custom': false"
            :sort-by="item.sortKey"
            :width="item.width">
                <template slot-scope="scope">
                <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
                <span v-else>{{scope.row[item.prop]}}</span>
                <el-tooltip v-if="item.handle" effect="dark" content="编辑" placement="top-start">
                    <el-button class="p0 fontsize20" type="text" @click="editTemplate(scope.row)"><i class="el-icon-edit-outline"></i></el-button>
                </el-tooltip>
                <el-tooltip v-if="item.handle" effect="dark" content="删除" placement="top-start">
                    <el-button class="p0 fontsize20" type="text" @click.prevent="deleteTemplate(scope.row.id)"><i class="el-icon-delete"></i></el-button>
                </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        </div>
        <pagination :queryParams="queryParams" :getList="gettemplateList" />
    </div>
    <!-- 新建、编辑模板对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="1200px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" :inline="true" id="basic-template-edit-dialog">
        <el-form-item label="模板名称" clearable prop="name">
          <el-input v-model="form.name" placeholder="请输入模板名称" />
        </el-form-item>
        <el-form-item label="科室" prop="department_id">
          <el-select v-model="form.department_id" clearable filterable placeholder="请选择科室">
            <el-option
              v-for="item in deptOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="器械包名称" prop="goods">
          <el-select v-model="goods" filterable clearable remote :remote-method="filterInstrumentPackage" placeholder="请选择器械包名称" @focus="filterInstrumentPackage('')">
            <el-option
              v-for="(item, index) in packageOptions"
              :key="`gd_${index}`"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量" prop="goods" v-if="this.type == 2">
          <el-input-number v-model="number" :min="1" label="描述文字"></el-input-number>
        </el-form-item>
        <el-button class="mt5" size="mini" :loading="buttonLoading" @click="packageinsert" type="primary">添加</el-button>
         <el-table :data="packageList" border row-key="id" stripe align="left" v-if="this.type == 2">
              <template v-for="(item, index) in col">
                <el-table-column
                align="center"
                v-if="dropCol[index].prop"
                :key="`col_${index}`"
                :prop="dropCol[index].prop"
                :label="item.label">
                </el-table-column>
                <el-table-column
                align="center"
                v-else
                :key="`col_${index}`"
                :label="item.label">
                  <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                          <el-button class="p0 fontsize20" type="text" @click.prevent="removePackage(scope.$index)"><i class="el-icon-delete"></i></el-button>
                      </el-tooltip>
                  </template>
                </el-table-column>
              </template>
          </el-table>
          <el-table :data="packageList" border row-key="id" stripe align="left" v-if="this.type != 2">
              <template v-for="(item, index) in colrecycle">
                <el-table-column
                align="center"
                v-if="dropColrecycle[index].prop"
                :key="`col_${index}`"
                :prop="dropColrecycle[index].prop"
                :label="item.label">
                </el-table-column>
                <el-table-column
                align="center"
                v-else
                :key="`col_${index}`"
                :label="item.label">
                  <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                          <el-button class="p0 fontsize20" type="text" @click.prevent="removePackage(scope.$index)"><i class="el-icon-delete"></i></el-button>
                      </el-tooltip>
                  </template>
                </el-table-column>
              </template>
          </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" :loading="buttonLoading" type="primary" @click="submitForm">保 存</el-button>
        <el-button size="mini" @click="open = false;">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination.vue'
import TableHeaderEditor from '@/components/common/TableHeaderEditor.vue'
import { templateList,templateEdit, templateDelete,getTemplateGoods,departmentOptions,getnameType } from '@/api.js' 
import { pageSize } from '@/utils/Config.js'
export default {
    name:'templateManagement',
    components: {
      Pagination,
      TableHeaderEditor
    },
    data() {
        return {
            // 查询参数
            queryParams: {
              pageIndex: 1,
              pageSize,
              _total: 0,
              name: '',
              department_id:'',
              type:'',
              department_name:'',
            },
            tableHeaders: [],
            //模板列表
            templetedataList:[],
            packageList:[],
            templeteOption:[],
            goods:'',
            number: 1,
            col: [
              {label: '器械包名称',prop: 'name'},
              {label: '数量',prop: 'number'},
              {label: '操作',prop: ''},
            ],
            dropCol: [
              {label: '器械包名称',prop: 'name'},
              {label: '数量',prop: 'number'},
              {label: '操作',prop: ''},
            ],
            colrecycle: [
              {label: '器械包名称',prop: 'name'},
              {label: '操作',prop: ''},
            ],
            dropColrecycle: [
              {label: '器械包名称',prop: 'name'},
              {label: '操作',prop: ''},
            ],
            loading:true,
            //科室数据
            deptOptions:[],
            packageOptions:[],
            //模板类型
            typeOptions:[],
            type: 1,
            // 弹出层标题
            title: "",
            // 按钮loading 
            buttonLoading: false,
            // 科室弹出层
            open: false,
            // 表单参数
            form: {},
            // 科室表单校验
            rules: {
              name: [
                { required: true, message: "模板名称不能为空", trigger: "blur" }
              ],
              type: [
                { required: true, message: "科室类型不能为空", trigger: "blur" }
              ],
            },
        }
    },
    methods: {
      openTab(type) {
        this.type = type
        this.queryParams.name = '';
        this.queryParams.department_name = '';
        this.gettemplateList();
        this.getdeptList();
        this.searchTypeOption();
        this.searchTemplete();
      },
      // 表单重置
      reset() {
        this.form = {
          name:undefined,
          department_id:undefined,
          type:undefined,
        };
        this.goods = [];
        this.number = 1;
        this.packageList = [];
      },
      /** 查询模板列表 */
      getSearch(){
        this.queryParams.pageIndex = 1;
        this.gettemplateList();
      },
      gettemplateList() {
        // 获取列表数据
        const url = templateList
        const {
          pageIndex,
          pageSize,
          name,
          department_name,
          orderBy,
          order
        } = this.queryParams
        const queryParams = {
          page: pageIndex,
          per_page: pageSize,
          name,
          department_name,
          type: this.type,
          order_column: orderBy,
          order,
        }
        this.$request('get', url, queryParams)
        .then((res) => {
          if (res) {
            const prev = [
              { 
                width: 60,
                label: '#',
                prop: '',
                type: 'index',
                checked: true
              }
            ]
            const last = [
              {
                width: 'auto',
                label: '操作',
                prop: '',
                checked: true,
                handle: true
              }
            ]

            this.tableHeaders = this.tableHeaders.length > 0 ? this.tableHeaders : this.$utils.generateColumns(res.columns, prev, last)
            // console.log(this.tableHeaders);
            this.templetedataList = res.data;
            this.queryParams._total = res.total;
          }
        })
        this.loading = false;
      },
      sortChange(item) {
        // 排序方法
        const { column, order } = item
        const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
        const orderBy = order ? column.sortBy : undefined

        this.queryParams.order = orderString
        this.queryParams.orderBy = orderBy
        this.gettemplateList()
      },
      //查询科室
      getdeptList(){
        const url = departmentOptions
        this.$request('get', url).then(res=>{
            this.deptOptions = res;
        })
      },
      //查询品名
      async filterInstrumentPackage(query = '') {
        const { department_id } = this.form
        const type =  this.type
        if (!department_id && type === 1) {
          this.$message.warning('请先选择科室')

          this.packageOptions = []

          return
        }
        const goods = await this.$request('get', getTemplateGoods, {name: query, type, department_id}).then(res => res)
        
        this.packageOptions = goods
      },
      //查询模板
      searchTemplete(){
        const url = getnameType
        this.$request('get', url).then(res=>{
          this.templeteOption = res.filter(i => i.type === this.type)
        })
      },
      //查询模板类型
      searchTypeOption(){
        return this.$utils.getDict(307).then((typeOptions) => {
          if(typeOptions){
            this.typeOptions = typeOptions[307];
          }
        })
      },
      initDraggable() {
        // 初始化拖拽
        this.$nextTick(() => {
          const tbody = document.querySelector('#basic-template-edit-dialog .el-table__body-wrapper tbody')
          const _this = this

          this.$sort.create(tbody, {
            onEnd({ newIndex, oldIndex }) {
              const currRow = _this.packageList.splice(oldIndex, 1)[0]
              _this.packageList.splice(newIndex, 0, currRow)
            }
          });
        })
      },
      // 新建模板
      createTemplate(){
        this.reset();
        this.open = true;
        this.title = "新建模板";
        this.initDraggable()
      },
      //添加品名
      packageinsert(){
        if(this.goods > 0){
          for (var i = 0; i < this.packageList.length; i++) {
            if (this.packageList[i].instrumentset_id == this.goods) {
              this.$message.warning('包名有重复的，请重新选择')
              return false;
            }
          }
          for (let j = 0; j < this.packageOptions.length; j++) {
            if(this.goods == this.packageOptions[j].id){
              this.packageList.push({
                name: this.packageOptions[j].name,
                instrumentset_id: this.goods,
                number: this.number,
                id: 0 - this.packageOptions[j].id
              });
            }
          }
        }else{
          this.$message.warning('请选择包名后添加')
        }
      },
      //删除品名
      removePackage: function(index) {
        this.packageList.splice(index,1);
      },
      //编辑模板
      editTemplate(row) {
        this.reset();
        this.form = row;
        const url = templateEdit.replace('{id}', row.id)
        this.$request('get', url,{}).then(res=>{
          for (let i = 0; i < res.goods.length; i++) {
              this.packageList.push({
                name:res.goods[i].instrumentset_name,
                instrumentset_id:res.goods[i].instrumentset_id,
                number:res.goods[i].number,
                id:res.goods[i].id
              })
          }
        })
        this.open = true;
        this.title = "编辑模板";
        this.initDraggable()
      },
      //删除模板
      deleteTemplate(id) {
        this.$confirm('确认删除吗？',{
          type: 'warning'
        })
        .then(() => { 
          const url = templateDelete.replace('{id}', id)
          this.$request('post', url, {})
          .then((res) => {
            if (res) {
              this.$message.success('删除成功')
              this.gettemplateList()
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
      },
      // 模板保存
      submitForm: function() {
        if (this.packageList == '') {
          this.$message.warning('请添加包信息！')
        }else{
          this.$refs["form"].validate(valid => {
            if (valid) {
              this.buttonLoading = true;
              this.form.goods = this.packageList.map(i => {
                if (i.id < 0) {
                  delete i.id
                }

                return i
              })
              
              if (this.form.id != null) {
                  const url = templateEdit.replace('{id}', this.form.id)
                  this.$request('post', url, this.form).then(res => {
                    if(res){
                      this.$message.success('修改成功');
                      this.open = false;
                      this.searchTemplete();
                      this.gettemplateList();
                    }
                }).finally(() => {
                  this.buttonLoading = false;
                });
              } else {
                this.form.type = this.type
                const urltwo = templateList
                this.$request('post', urltwo, this.form).then(res => {
                  if(res){
                    this.$message.success('新增成功');
                    this.open = false;
                    this.searchTemplete();
                    this.gettemplateList();
                  }
                }).finally(() => {
                  this.buttonLoading = false;
                });
              }
            }
          });
        }
      },
    }
}
</script>

<style lang="scss" scoped>
.instrument_index{
  .instrument_center{
    background: white;
    padding: 10px;
    border-radius: 10px;
  }
  .imageSize{
    font-size: 22px;
  }
  .header-editor {
    position: relative;
    right: 10px;
    z-index: 5;
    top:5px;
  }
} 
</style>